<template lang="pug">
    div
        div(class="lg:flex lg:-m-3")
            div(
                v-if="pData.featureVideo || pData.featureBlocks || (pData.features && pData.features.content) || pData.description"
                class="lg:flex-1 lg:m-3"
            )
                div(
                    v-if="pData.featureVideo"
                    ref="featureVideo"
                    class="my-3"
                )
                    Video(:video="pData.featureVideo")
                div(v-if="pData.featureBlocks")
                    ImageList(
                        :data="pData.featureBlocks"
                        mode='blocks'
                        :thirds="!pData.specSheet && !pData.inTheBox && !pData.guarantee"
                    )
                div(v-if="pData.features && pData.features.content && !pData.hasOverriddenFeatureBullets" v-html="pData.features.content")
                div(v-if="pData.description")
                    div(v-if="pData.description.main" v-html="pData.description.main")
                    div(v-if="pData.description.extended" v-html="pData.description.extended")
            div(
                v-if="(pData.specSheet && pData.specSheet.length > 1) || pData.inTheBox || pData.guarantee"
                class="w-full lg:m-3 lg:w-1/3"
            )
                SpecSheet(
                    class="mt-3"
                    :class="{'has-video' : pData.featureVideo}"
                )
        div(class="lg:w-2/3")
            FocusedReview(v-if="$yotpo.enabled" :yotpoId="pData.yotpoId")
        div(class="prop-65 relative inline-block font-bold mt-4 mb-3 group")
            | California Residents:&nbsp;
            span(class="font-normal underline cursor-pointer") Prop 65 Warning
            div(class="absolute left-0 right-0 bottom-full hidden group-hover:block")
                Prop65
        div(v-if="pData.orderNotes")
            h3 Order Notes
            div(v-html="pData.orderNotes")
        div(v-if="pData.shipping && pData.shipping.notes")
            h3 Shipping Notes
            div(v-html="pData.shipping.notes")
        div(v-if="pData.features && (pData.features.files || pData.features.videos)")
            h3 More Information
            FileList(v-if="pData.features && pData.features.files" :files="pData.features.files")
            VideoList(v-if="pData.features && pData.features.videos" :videos="pData.features.videos")
</template>

<script>
import Video from '@/components/video'
import Prop65 from '@/assets/prop65'
import FocusedReview from '@/integrations/yotpo/focusedReview'
import FileList from '../fileList'
import VideoList from '../videoList'
import ImageList from '../imageList'
import SpecSheet from './specSheet'

export default {
    name: 'Description',
    components: {
        Video,
        Prop65,
        SpecSheet,
        FileList,
        VideoList,
        ImageList,
        FocusedReview,
    },
    computed: {
        pData() {
            return this.$store.state.product.data
        },
    },
}
</script>
<style lang="stylus" scoped>
.prop-65 >>> svg
    width 100%
    max-width 300px
    max-height 56px
    box-shadow 1px 1px 5px 0px rgba(0,0,0,.6)

@screen lg
    .has-video
        min-height 355px
@screen xl
    .has-video
        min-height 427px
</style>
